
// import SideBar from '../components/SideBar';
import DetailsPageHeader from '../../components/DetailsPageHeader';
import OrderDetailsTab from '../../components/OrderDetailsTab';
import { ReactComponent as MultiFileIcon} from '../../components/svgs/multiFileIcon.svg';
import ManagerSidebar from '../../components/manager/ManagerSidebar';


const ManagerOrderDetailsScreen = () => {


  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
            <ManagerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'order'} customerDetails={'order #23'} showButton={false}/>
            <section className='mt-10 flex gap-5 laundry-details-title-section'>
                <div className='laundry-details-title-container'>
                    <div className='laundry-details-title-items gap-10'>
                        <div className='multi-file-icon-border'>
                            <MultiFileIcon className='ml-5 mt-5'/>
                        </div>
                        <div className='flex flex-col'>
                            <p className='order-id'>Order #23</p>
                            <div className='flex gap-4'>
                                <p className='order-status'>In laundry</p>
                                <div className='order-status-dropdown'>
                                    
                                    <select className='mt-6'>
                                        <option value="option1">Binned</option>
                                        <option value="option2">Washing</option>
                                        <option value="option3">Drying</option>
                                        <option value="option3">Folding</option>
                                        <option value="option3">Complete</option>
                                        {/* <option value="option3">Laundry Works</option> */}
                                    </select>
                                
                                </div>
                            </div>
                            
                        </div>
                        <section className='order-details-more-options'>
                                <div className='order-status-option-dropdown'>
                                    
                                    <select className='mt-6'>
                                        <option value="option1">More options</option>
                                        <option value="option2">Edit order</option>
                                        <option value="option3">Duplicate order</option>
                                        <option value="option3">Print order</option>
                                        <option value="option3">Archive order</option>
                                        {/* <option value="option3">Laundry Works</option> */}
                                    </select>
                                
                                </div>
                        </section>
                        
                    </div>
                    
                </div>
                <div>
                <div className='flex gap-44 p-6'>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Customer</p>
                        <div className='flex gap-4'>
                            <div className='company-initials mt-4'>
                                <p className='company-initials-text'>GI</p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='company-name'>Geller Industries</p>
                                <p className='company-rep'>Monica Geller</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>No of bags</p>
                        <p className='no-of-bags'>3</p>
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Size</p>
                        <p className='total-price'>45lbs</p>
                        
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Due date</p>
                        <p className='total-price'>31/12/23</p>
                        
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Time</p>
                        <p className='total-price'>18:00</p>
                        
                    </div>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Creation date</p>
                        <p className='total-price'>12/11/23</p>
                        
                    </div>
                </div>
                </div>
            </section>
            <section className='mt-20 flex gap-4'>
                <section>
                    <OrderDetailsTab/>
                
                
            </section>
            {/* <section className='side-card-section'>
              <SideCard/>
            </section> */}
          </section>
        </main>
      </section>
    </>
  )
}

export default ManagerOrderDetailsScreen